






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import QuickSnack from "@/components/QuickSnack.vue";
import { deleteTopayMessage } from "@/domain/backend/vending";
import { Branch, Terminal } from "@/domain";
import { logError } from "@/util";
import { VendingConfig } from "@/domain/api";

@Component({
  components: { QuickSnack }
})
export default class VendingTopayClearMessages extends Vue {
  @Prop() branch!: Branch | null;
  @Prop() terminal!: Terminal | null;
  @Prop() config!: VendingConfig | null;
  showClearTopayDialog = false;
  executingClearTopay = false;

  get lang() {
    return this.$store.state.lang.data;
  }

  get snackbar() {
    return this.$refs.snackbar as QuickSnack;
  }

  get tcod() {
    return this.config?.TCOD;
  }

  setVisible(show: boolean) {
    this.showClearTopayDialog = show;
  }

  @Watch("config")
  onConfigChanged() {
    this.setVisible(false);
  }

  async clearToPayMsgs() {
    const tcod = this.terminal?.tcod || null;
    const branchID = this.branch?.id || null;

    if (!tcod || !branchID) return this.snackbar.show("Invalid branch or TCOD ", "error");
    this.executingClearTopay = true;
    try {
      const res = await deleteTopayMessage("massive", tcod);
      if (res.saved) {
        this.snackbar.show(this.lang.toPayMessageDeleted, "success");
      } else {
        this.snackbar.show("Error: " + res.message, "error");
      }
    } catch (err) {
      logError("Error deleting topay message", { err });
      this.snackbar.show(this.lang.errorSaving + (err as Error).message, "error");
    } finally {
      this.executingClearTopay = false;
      this.showClearTopayDialog = false;
    }
  }
}
